/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
( function() {
	var container, button, menu, links, i, len, body, scrolltop_item;

	container = document.querySelector( '#site-navigation' );
	if ( ! container ) {
		return;
	}

	button = document.querySelector( '#site-navigation #menu-toggle' );
	if ( 'undefined' === typeof button ) {
		return;
	}

	menu = document.querySelector( '#site-navigation .navbar-menu' );
	
	console.log("aqui");
	body = document.querySelector( 'body' );
	scrolltop_item = document.createElement("div");
	scrolltop_item.className = "scrolltop";
	
	body.appendChild(scrolltop_item);
	console.log(body, scrolltop_item);
	
	

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}

	menu.setAttribute( 'aria-expanded', 'false' );
	if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
		menu.className += ' nav-menu';
	}

	console.log(button);
	button.onclick = function() {
		if ( -1 !== button.className.indexOf( 'is-active' ) ) {
			button.className = button.className.replace( ' is-active', '' );
			menu.className = menu.className.replace( ' is-active', '' );
			
			button.setAttribute( 'aria-expanded', 'false' );
			menu.setAttribute( 'aria-expanded', 'false' );
		} else {
			button.className += ' is-active';
			menu.className += ' is-active';
			
			button.setAttribute( 'aria-expanded', 'true' );
			menu.setAttribute( 'aria-expanded', 'true' );
		}
	};
	scrolltop_item.onclick = function () {
		$('html, body').stop().animate({
			scrollTop: 0
		}, 300);
	};

	// Get all the link elements within the menu.
	links    = menu.getElementsByTagName( 'a' );
	console.log(links);

	// Each time a menu link is focused or blurred, toggle focus.
	for ( i = 0, len = links.length; i < len; i++ ) {
		links[i].addEventListener( 'focus', toggleFocus, true );
		links[i].addEventListener( 'blur', toggleFocus, true );
		links[i].addEventListener( 'click', itemMenuAction, true );
	}
	
	// Bind click handler to anchors scroll animation
	function itemMenuAction(e) {
		var href = $(this).attr("href");
		
		if(href.indexOf('#') == 0) {
			var topMenu = $("#site-header"),
				topMenuHeight = topMenu.outerHeight() + 15,
				offsetTop = $(href).length ? $(href).offset().top - topMenuHeight + 1 : 0;
				
			$('html, body').stop().animate({
				scrollTop: offsetTop
			}, 300);
			
			e.preventDefault();
		}
	};

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		var self = this;

		// Move up through the ancestors of the current link until we hit .nav-menu.
		while ( -1 === self.className.indexOf( 'nav-menu' ) ) {

			// On li elements toggle the class .focus.
			if ( 'li' === self.tagName.toLowerCase() ) {
				if ( -1 !== self.className.indexOf( 'focus' ) ) {
					self.className = self.className.replace( ' focus', '' );
				} else {
					self.className += ' focus';
				}
			}

			self = self.parentElement;
		}
	}

	/**
	 * Toggles `focus` class to allow submenu access on tablets.
	 */
	( function( container ) {
		var touchStartFn, i,
			parentLink = container.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

		if ( 'ontouchstart' in window ) {
			touchStartFn = function( e ) {
				var menuItem = this.parentNode, i;

				if ( ! menuItem.classList.contains( 'focus' ) ) {
					e.preventDefault();
					for ( i = 0; i < menuItem.parentNode.children.length; ++i ) {
						if ( menuItem === menuItem.parentNode.children[i] ) {
							continue;
						}
						menuItem.parentNode.children[i].classList.remove( 'focus' );
					}
					menuItem.classList.add( 'focus' );
				} else {
					menuItem.classList.remove( 'focus' );
				}
			};

			for ( i = 0; i < parentLink.length; ++i ) {
				parentLink[i].addEventListener( 'touchstart', touchStartFn, false );
			}
		}
	}( container ) );
} )();
